/* eslint-disable no-unused-vars */
// false-positive when defining enum
export enum ROLES {
    SUPER_ADMIN = 'super_admin',

    TEACHER = 'teacher',
    TEACHING_ASSISTANT = 'teaching_assistant',
    CLASS_ASSISTANT = 'class_assistant',
    CURRICULUM_ADMIN = 'curriculum_admin',
    BRANCH_MANAGER = 'branch_manager',
    STUDENT_CARE = 'student_care',
    STUDENT_SUCCESS = 'student_success',
}

export enum PERMISSIONS {
    // feedback mgmt
    FEEDBACK_READ = 'paula:read:feedback',
    FEEDBACK_WRITE = 'paula:write:feedback',

    // curriculum mgmt
    CURRICULUM_READ = 'paula:read:curriculum',
    CURRICULUM_WRITE = 'paula:write:curriculum',

    // learning plan mgmt
    LEARNING_PLAN_READ = 'paula:read:learning_plan',
    LEARNING_PLAN_WRITE = 'paula:write:learning_plan',

    // student tracker mgmt
    TRACKER_READ = 'paula:read:tracker',

    // learning summary mgmt
    LEARNING_SUMMARY_READ = 'paula:read:learning_summary',
    LEARNING_SUMMARY_APPROVAL_WRITE = 'paula:write:learning_summary_approval',
    LEARNING_SUMMARY_RELEASE_WRITE = 'paula:write:learning_summary_release',
    LEARNING_SUMMARY_LEVEL_ACTION_WRITE = 'paula:write:learning_summary_level_action',

    // super admin paula
    READ_ALL = 'paula:read:all',
    ALL = 'paula:all:all',
}

export type RouteItem = {
    name: string;
    path: string;
    exact: boolean;
    showOnNavbar?: boolean;
    component: any;
    roles?: Array<ROLES>; // List of Posibilities Value
    permissions?: Array<PERMISSIONS>;
};
